/*
 * Visualiseur InstrumenPoche en Javascript et SVG
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const ActionAncetre = require('./actionAncetre')
module.exports = ActionMontrer
/**
 * Action montrant un objet.
 * @extends iep.actionAncetre
 * @constructor
 * @param {iep.iepDoc} doc : le document propriétaire
 * @param {iep.objetBase} objet : l'objet à démasquer
 */
function ActionMontrer (doc, idel, nature, tempo) {
  ActionAncetre.call(this, doc, tempo)
  this.objet = this.doc.getElement(idel, nature)
}
ActionMontrer.prototype = new ActionAncetre()
/**
 * Fonction démasquant l'élément graphique de l'objet objet
 * @param {type} immediat
 */
ActionMontrer.prototype.execute = function (immediat) {
  const el = this.objet
  if (el !== null) el.montre(true)
  if (!immediat) this.doc.actionSuivante(immediat)
}
/** @inheritDoc */
ActionMontrer.prototype.actionVisible = function () {
  return !this.doc.getObjectVisibility(this.objet, this.indice - 1)
}
